<template>
  <div class="heading-container">
    <!-- Swiss style header -->
    <div class="header">
      <div class="name">{{ heading.name }}</div>
      <div class="contact-info">
        <div class="job-title">{{ heading.title }}</div>
        <slot name="contact"></slot>
      </div>
    </div>

    <!-- Large title -->
    <div class="title-section">
      <h1>resume</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Heading",
  props: {
    heading: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.heading-container {
  grid-column: 1 / 13;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10mm;
}

.name {
  font-size: 24pt;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.contact-info {
  text-align: right;
  font-size: 8pt;
  line-height: 1.5;
  font-weight: 400;
}

.job-title {
  font-weight: 700;
  margin-bottom: 3mm;
  white-space: pre-line;
}

.title-section {
  margin-bottom: 15mm;
}

.title-section h1 {
  font-size: 72pt;
  font-weight: 700;
  letter-spacing: -2px;
  line-height: 1;
  text-transform: lowercase;
}

@media screen and (max-width: 202mm) {
  .title-section h1 {
    font-size: 48pt;
  }
  
  .name {
    font-size: 18pt;
  }
  
  .header {
    flex-direction: column;
    gap: 3mm;
  }
  
  .contact-info {
    text-align: left;
  }
}
</style>
